import { createClient } from '@supabase/supabase-js';

import { publicEnv } from '../env';

export const supabase = createClient(
  publicEnv.VITE_SUPABASE_URL,
  publicEnv.VITE_SUPABASE_ANON_KEY,
  {
    auth: {
      autoRefreshToken: true,
      detectSessionInUrl: true,
      persistSession: true,
    },
  }
);
